import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';

const TableBody = ({className, ...rest}) => {
  return <tbody className={classnames('o-table__table-body', className)} {...rest} />;
};

TableBody.propTypes = {
  className: PropTypes.string
};

export default TableBody;
